import { periodMinutesForDay } from './period-minutes-for-day';
import { leaveTypesThatAllowPlusTime } from './leave-types-that-allow-plus-time';
import { rangesMinusRanges } from './ranges-minus-ranges';
import { summarizeRanges } from './summarize-ranges';

export function validPlusTimeMinutes(
  plusTimeStartMinutes,
  plusTimeEndMinutes,
  workStartMinutes,
  workEndMinutes,
  leavePeriods,
  day,
) {
  const offPeriodsInMinutes = periodMinutesForDay(leavePeriods, leaveTypesThatAllowPlusTime, true, day);
  const workPeriodsInMinutes = [
    {
      start: workStartMinutes,
      end: workEndMinutes,
    },
  ];
  const workPeriodsNotOnLeave = rangesMinusRanges(workPeriodsInMinutes, offPeriodsInMinutes);
  const validPlusTimeRanges = rangesMinusRanges(
    [{ start: plusTimeStartMinutes, end: plusTimeEndMinutes }],
    workPeriodsNotOnLeave,
  );
  return summarizeRanges(validPlusTimeRanges);
}
